export const keys = {
  user: 'user',
  config: 'config',
  files: 'files',
  aiJobs: 'ai-jobs',
}
